import React from "react";

import Products from "./Products";

import Button from "@material-ui/core/Button";

const ProductsMain = () => {
  return (
    <div id="products">
      <div className="container">
        <h1
          className="all_products_title"
          style={{
            marginTop: "0"
          }}
        >
          Ассортимент
        </h1>
        <div className="products_wrapper">
          <Products />
        </div>
        <div className="link_wrapper">
          <Button variant="contained" href="/products/Продукты" >
            Все Продукты
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProductsMain;
